// extracted by mini-css-extract-plugin
module.exports = {"root":"Layout_root__sPKXo","wrap":"Layout_wrap__2GxNk","content":"Layout_content__3jcOu"};